import { useEffect, useState } from 'react';

export type SectionStatus = 'loading' | 'ready';

/** Stand-in pause so each section can show its skeleton before mock content. */
export const MOCK_SECTION_DELAY_MS = 600;

function skipMockDelay(): boolean {
  if (process.env.NODE_ENV === 'test') {
    return true;
  }
  return (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/**
 * Each home section calls this on its own.
 * Swap the timeout for a real request when the marketing APIs exist.
 */
export function useMockSection(delayMs: number): SectionStatus {
  const [status, setStatus] = useState<SectionStatus>(() => (skipMockDelay() ? 'ready' : 'loading'));

  useEffect(() => {
    if (skipMockDelay()) {
      setStatus('ready');
      return undefined;
    }
    const timer = window.setTimeout(() => setStatus('ready'), delayMs);
    return () => window.clearTimeout(timer);
  }, [delayMs]);

  return status;
}
